export default __webpack_public_path__ + "static/media/093-turn-left-3.b696e157.png";